import React from 'react';
import { Link } from 'react-router-dom';
import heroVideo from '../../assets/telematics.webm'; 

function HeroBanner() {
  return (
    <section
      id="home"
      className="relative mx-2 flex min-h-[600px] items-center overflow-hidden rounded-b-[2rem] px-5 pb-16 pt-28 text-white sm:px-8 lg:min-h-[700px] lg:px-12 lg:pt-32"
    >
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 h-full w-full object-cover"
      >
        <source src={heroVideo} type="video/webm" />
      </video>

      <div className="absolute inset-0 bg-black/45" />
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/35 to-black/55" />

      <div className="relative z-10 mx-auto w-full max-w-[1470px] px-4 lg:px-6">
        <div className="w-full">
          
          <h1 className="text-[36px] font-semibold leading-[1.2] tracking-[-0.02em] text-white sm:text-[48px] lg:text-[64px]">
            Make Fleet Operations Smarter and
            <br className="hidden md:block" /> More Profitable{" "}
            
            <span className="relative inline-block whitespace-nowrap text-[#df8b2d]">
              with Veyonta
              <svg
                viewBox="0 0 320 25"
                preserveAspectRatio="none"
                className="absolute -bottom-3 left-0 h-4 w-full"
              >
                <path
                  d="M2 5 C70 22 140 18 220 10 C260 6 295 8 318 12"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="3"
                  strokeLinecap="round"
                />
              </svg>
            </span>
          </h1>

          <p className="mt-8 max-w-[620px] text-base leading-relaxed text-white/90 sm:mt-10 sm:text-lg sm:leading-8">
            Every mile matters. At Veyonta Systems, we empower you with
            complete control over your fleet using advanced tracking,
            monitoring, and real-time analytics—purpose-built for growing
            and modern logistics businesses.
          </p>

          <div className="mt-8 sm:mt-10">
            <Link
              to="/contact"
              className="inline-flex h-14 items-center justify-center rounded-xl bg-[#df8b2d] px-10 text-base font-medium text-white transition-all duration-300 hover:scale-105 hover:bg-[#c97922]"
            >
              Contact us
            </Link>
          </div>
          
        </div>
      </div>
    </section>
  );
}

export default HeroBanner;